/* Inergize Attribution Tracking + getBookingUrl() + PDP link interceptor + Floating call widget */
(function(){
  var p = new URLSearchParams(window.location.search);
  var prefix = 'inergize_';
  ['gclid','gbraid','wbraid','fbclid'].forEach(function(k){
    var v = p.get(k);
    if(v){
      localStorage.setItem(prefix + k, v);
      sessionStorage.setItem(prefix + k, v);
      document.cookie = prefix + k + '=' + v + ';max-age=7776000;path=/;SameSite=Lax';
    }
  });
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_placement'].forEach(function(k){
    var v = p.get(k);
    if(v){
      localStorage.setItem(prefix + k, v);
      sessionStorage.setItem(prefix + k, v);
      document.cookie = prefix + k + '=' + v + ';max-age=7776000;path=/;SameSite=Lax';
    }
  });
  if(!localStorage.getItem(prefix + 'landing_page')){
    localStorage.setItem(prefix + 'landing_page', window.location.href);
    localStorage.setItem(prefix + 'referrer', document.referrer || '');
    localStorage.setItem(prefix + 'first_touch_ts', new Date().toISOString());
  }
  localStorage.setItem(prefix + 'latest_touch_ts', new Date().toISOString());

  /* Sync UTMs to Shopify cart note_attributes so abandoned checkout webhooks carry attribution */
  function syncToCart() {
    var attrs = {};
    var keys = ['gclid','gbraid','wbraid','fbclid','utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_placement','landing_page','referrer','first_touch_ts','latest_touch_ts'];
    var hasAny = false;
    keys.forEach(function(k) {
      var v = localStorage.getItem(prefix + k);
      if (v) { attrs[k] = v; hasAny = true; }
    });
    if (hasAny) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function(){});
    }
  }
  syncToCart();
})();

/* Global getBookingUrl() — appends all attribution params to GHL booking link */
function getBookingUrl(bookingAsset) {
  var base = 'https://api.leadconnectorhq.com/widget/bookings/inergize';
  var prefix = 'inergize_';
  // Detect product interest from current page
  var productInterest = '';
  if (window.meta && window.meta.product) {
    var h = window.meta.product.handle || '';
    if (h.indexOf('spire') !== -1 && h.indexOf('apex') !== -1) productInterest = 'Spire Apex';
    else if (h.indexOf('spire') !== -1) productInterest = 'Spire Elite';
    else if (h.indexOf('elite') !== -1) productInterest = 'Elite Tub';
    else if (h.indexOf('chiller') !== -1) productInterest = 'Chiller';
    else productInterest = window.meta.product.title || '';
  }
  var params = new URLSearchParams({
    utm_source: localStorage.getItem(prefix + 'utm_source') || '',
    utm_medium: localStorage.getItem(prefix + 'utm_medium') || '',
    utm_campaign: localStorage.getItem(prefix + 'utm_campaign') || '',
    utm_content: localStorage.getItem(prefix + 'utm_content') || '',
    utm_term: localStorage.getItem(prefix + 'utm_term') || '',
    utm_placement: localStorage.getItem(prefix + 'utm_placement') || '',
    gclid: localStorage.getItem(prefix + 'gclid') || '',
    gbraid: localStorage.getItem(prefix + 'gbraid') || '',
    wbraid: localStorage.getItem(prefix + 'wbraid') || '',
    fbclid: localStorage.getItem(prefix + 'fbclid') || '',
    booking_asset: bookingAsset || '',
    product_interest: productInterest,
    landing_page: localStorage.getItem(prefix + 'landing_page') || '',
    referrer: localStorage.getItem(prefix + 'referrer') || '',
    first_touch_ts: localStorage.getItem(prefix + 'first_touch_ts') || '',
    latest_touch_ts: new Date().toISOString(),
    source_form: 'booking_form',
    form_page: window.location.href
  });
  return base + '?' + params.toString();
}

/* PDP Link Interceptor — catches clicks on old booking/virtual-tour links and routes through getBookingUrl() */
document.addEventListener('click', function(e) {
  var link = e.target.closest('a');
  if (!link) return;
  var href = link.getAttribute('href') || '';
  // Match old booking page links and direct GHL booking links
  if (href.indexOf('need-help-try-our-virtual-tour') !== -1 ||
      href.indexOf('api.leadconnectorhq.com/widget/bookings') !== -1) {
    e.preventDefault();
    // Determine booking asset from context
    var asset = 'pdp_' + (window.meta && window.meta.product ? window.meta.product.handle : 'unknown');
    // Check if it's from a known location
    if (link.closest('.site-footer, footer, .footer')) asset = 'footer_cta';
    if (link.closest('.announcement-bar, .toolbar')) asset = 'announcement_bar';
    window.open(getBookingUrl(asset), '_blank');
  }
}, true);

/* Floating Call Widget — animated, positioned above Gorgias */
(function(){
  function createCallWidget() {
    // Don't show on thank-you pages or checkout
    if (window.location.pathname.indexOf('thank-you') !== -1) return;
    if (window.location.pathname.indexOf('checkout') !== -1) return;

    var style = document.createElement('style');
    style.textContent = [
      '/* 3 pulses x 2s = 6s active, 30s pause = 36s total cycle */',
      '/* 6s/36s = 16.67% active portion */',
      '@keyframes inergize-pulse-cycle {',
      '  0% { transform: scale(1); }',
      '  2.78% { transform: scale(1.08); }',
      '  5.56% { transform: scale(1); }',
      '  8.33% { transform: scale(1.08); }',
      '  11.11% { transform: scale(1); }',
      '  13.89% { transform: scale(1.08); }',
      '  16.67% { transform: scale(1); }',
      '  100% { transform: scale(1); }',
      '}',
      '#inergize-call-widget {',
      '  position: fixed;',
      '  bottom: 118px;',
      '  right: 30px;',
      '  z-index: 999998;',
      '  width: 60px;',
      '  height: 60px;',
      '  border-radius: 50%;',
      '  background: #2A2A2F;',
      '  display: flex;',
      '  align-items: center;',
      '  justify-content: center;',
      '  cursor: pointer;',
      '  box-shadow: 0 2px 4px rgba(22,22,22,0.16);',
      '  transition: box-shadow 0.2s;',
      '  animation: inergize-pulse-cycle 36s ease-in-out infinite;',
      '}',
      '#inergize-call-widget:hover {',
      '  box-shadow: 0 4px 10px rgba(22,22,22,0.3);',
      '}',
      '#inergize-call-widget svg {',
      '  width: 24px;',
      '  height: 24px;',
      '  fill: #ffffff;',
      '}',
      '@media (max-width: 768px) {',
      '  #inergize-call-widget {',
      '    bottom: 118px;',
      '    right: 30px;',
      '    width: 60px;',
      '    height: 60px;',
      '  }',
      '  #inergize-call-widget svg {',
      '    width: 24px;',
      '    height: 24px;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);

    var widget = document.createElement('div');
    widget.id = 'inergize-call-widget';
    widget.setAttribute('aria-label', 'Book a Call');
    widget.setAttribute('role', 'button');
    widget.setAttribute('tabindex', '0');
    widget.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"/></svg>';
    widget.addEventListener('click', function() {
      window.open(getBookingUrl('website_call_widget'), '_blank');
    });
    widget.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        window.open(getBookingUrl('website_call_widget'), '_blank');
      }
    });

    document.body.appendChild(widget);
  }

  /* Call widget DISABLED for now. The createCallWidget() function above is
     left fully intact — to re-activate, set ENABLE_CALL_WIDGET to true. */
  var ENABLE_CALL_WIDGET = false;
  if (ENABLE_CALL_WIDGET) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', createCallWidget);
    } else {
      createCallWidget();
    }
  }
})();

/* Gorgias Chat UTM Injection — ensures meta.current_page always has UTMs */
/* Gorgias captures window.location for each chat message's meta.current_page.
   If the visitor navigated away from the landing page, UTMs are lost from the URL.
   This silently re-adds UTMs to the URL via history.replaceState so Gorgias always sees them. */
(function(){
  var prefix = 'inergize_';
  // Only run if URL doesn't already have utm_source (i.e., they navigated away from ad landing)
  if (window.location.search.indexOf('utm_source') !== -1) return;
  
  var utmSource = localStorage.getItem(prefix + 'utm_source');
  if (!utmSource) return;
  
  var utmKeys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','gbraid','fbclid'];
  var params = new URLSearchParams(window.location.search);
  utmKeys.forEach(function(k) {
    var v = localStorage.getItem(prefix + k);
    if (v && !params.has(k)) params.set(k, v);
  });
  
  try {
    var newUrl = window.location.pathname + '?' + params.toString() + window.location.hash;
    history.replaceState(null, '', newUrl);
  } catch(e) {}
})();
